import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
 import Header1 from "../layouts/Header1";
import Footer from "../layouts/Footer";
import MobileNav from "./MobileNav";
import BottomNav from "./BottomNav";

const Layout = ({ children, title, logo, favicon }) => {
  let userCart = localStorage.getItem("cart");
  userCart = userCart ? JSON.parse(userCart) : [];
  return (
    <>
      <Header1 cartTotal={userCart.length}  logo={"/assets/images/logo.jpeg"}/>
      <MobileNav logo={logo} />
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={favicon} />
        </Helmet>
        {children}
      </HelmetProvider>
      <Footer />
      <BottomNav />
    </>
  );
};

export default Layout;
